import React from 'react'
import { Link, useLocation } from "react-router-dom";

function Footer() {
  const location = useLocation(); // Get the current route path
  return (
    <div id="footer-bar" className="footer-bar-1">
      <Link to="/skip" className={location.pathname === "/skip" ? "active-nav" : ""}>
      <i className="fa fa-home"></i><span>Home</span>
      </Link>
      
      <Link to="/Profile" className={location.pathname === "/Profile" ? "active-nav" : ""}>
      <i class="fa fa-list" aria-hidden="true"></i><span>More</span>
      </Link>
    </div>
  )
}

export default Footer